import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getApiHost, getQueryFetchOptions, parseHttpResponse } from '../utils';

export const MANIFEST_QUERY_KEY = 'manifest';

export const useManifestQuery: () => UseQueryResult<Manifest, Error> = () => {
  return useQuery<Manifest>({
    queryKey: [MANIFEST_QUERY_KEY],
    queryFn: async () => {
      const apiHost = getApiHost();
      const url = new URL('/api/web/manifest', apiHost);

      const response = await fetch(url, getQueryFetchOptions());

      return parseHttpResponse(response);
    },
  });
};

export type Manifest = {
  aggregate_restaurant_savings: {
    dollar_amount: number;
    description: string;
  };
  ccpa_url: string;
  chownow_marketing_privacy_url: string;
  customer_service_phone: string;
  payment_processor_key: string;
  privacy_policy_url: string;
  request_account_deletion_url: string;
  rewards_terms_url: string;
  terms_of_service_url: string;
};

export const MANIFEST_FALLBACK: Manifest = {
  ccpa_url:
    'https://chownow-requests.my.onetrust.com/webform/67994022-0d2e-4da4-af0f-30b990afab7a/b16058fc-4ca6-4d7a-a18d-d18b292f7d11',
  chownow_marketing_privacy_url: 'https://iterable.com/trust/privacy-policy/',
  payment_processor_key:
    'pk_test_51QwBfTRwS1nHZQFvrwAmcPmXy5zOI6GkC620ZaqLPBoBCL5QpRrDMgaBVDgSLtQUyvl6OJxWOKmKBZAy4MV8A3zL00IHk4RKlf',
  terms_of_service_url: 'https://get.chownow.com/terms-of-service',
  privacy_policy_url: 'https://get.chownow.com/privacy-policy',
  aggregate_restaurant_savings: {
    dollar_amount: 640000000, // current as of 07/2026
    description: 'Diners like you saved restaurants $640M since 2011.',
  },
  request_account_deletion_url:
    'https://chownow-requests.my.onetrust.com/webform/67994022-0d2e-4da4-af0f-30b990afab7a/b16058fc-4ca6-4d7a-a18d-d18b292f7d11',
  customer_service_phone: '18887072469',
  rewards_terms_url: 'https://get.chownow.com/legal/restaurant-rewards/',
};
